// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","sidebarWidget":"_2-u8nxN6rxyf6GW40PeB5L","noPadding":"IJp3lzuxGC18xfWnwRhGA"};